// src/components/ConfirmCommand.js
import React, { useEffect, useRef, useState } from "react";
import "./ConfirmCommand.css";


export default function ConfirmCommand({ isOpen, onClose, onConfirm }) {
  const dialogRef = useRef(null);
  const [loading, setLoading] = useState(false);

  

  useEffect(() => {
    if (isOpen) {
      setLoading(false); // reset quand on ouvre
      const btn = dialogRef.current?.querySelector("button");
      btn?.focus();
      const onKey = (e) => e.key === "Escape" && !loading && onClose?.();
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
    }
  }, [isOpen, onClose, loading]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    try {
      setLoading(false);
      onClose?.();
      await onConfirm?.();
    } finally {
      setLoading(false);
      onClose?.();
    }
  };

  return (
    <>
     <div className="modal-overlay-confirm" onClick={() => !loading && onClose?.()} aria-modal="true" role="dialog">
      <div
        className="modal-confirm"
        onClick={(e) => e.stopPropagation()}
        ref={dialogRef}
      >
        <h2 className="modal-title-confirm">Confirmation</h2>
        <p className="modal-message-confirm">
          Voulez-vous confirmer cette commande ? <br />
          Vous serez redirigé vers notre portail de paiement sécurisé afin de procéder au règlement.
        </p>
        <div className="modal-actions-confirm">
          <button
            className="btn-confirm"
            onClick={handleConfirm}
            disabled={loading}
          >
            Oui
          </button>
          <button
            className="btn-cancel-confirm"
            onClick={onClose}
            disabled={loading}
          >
            Non
          </button>
        </div>
      </div>
    </div>
    </>
  );
}
